import { render, staticRenderFns } from "./CoinbaseWalletNoticeWindow.vue?vue&type=template&id=6c83338b&scoped=true&"
import script from "./CoinbaseWalletNoticeWindow.vue?vue&type=script&lang=js&"
export * from "./CoinbaseWalletNoticeWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c83338b",
  null
  
)

export default component.exports